import { UserService } from './../../services/user.service';
import {AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {CodaltComponent} from '../codalt/codalt.component';
// import {MatPaginator} from '@angular/material/paginator';
import {combineLatest, fromEvent, Observable} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import {debounce} from '../../utils.class';
import {TtmTicketService} from '../../services/ttm-ticket.service';
import {ConfirmDialogService} from '../../services/confirm-dialog-service/confirm-dialog.service';
import {TtmTicket} from '../../classes/ttm-ticket.class';
import {TtmTicketDataSource} from './ttm-tickets-data-source.service';
import {AuthorisationService} from '../../services/auth/authorisation.service';
import {Ttm} from '../../classes/ttm';
import {TtmDetailsDialogComponent} from '../ttm-details-dialog/ttm-details-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {ProjectService} from '../../services/project.service';
import {TtmType} from '../../classes/ttmtype';
import {TtmStatus} from '../../classes/ttmstatus';
import {TtmService} from '../../services/ttm.service';
import {EntityImage} from '../../classes/entityimage';
import {Title} from '@angular/platform-browser';
import { FormControl, FormGroup } from '@angular/forms';
import { User } from '../../classes/user';
import { Router } from '@angular/router';
import { Routenames } from '../../routenames';
import { LocalStorage } from '../../utils/storage';
import { Roles } from '../../services/auth/roles';
import { TtmTicketTypePipe } from '../../pipes/ttm-ticket-type.pipe';
import { TtmTicketDepartmentOptions } from '../ttm-ticket-dialog/ttm-ticket-dialog.component';

@Component({
    selector: 'app-ttm-tickets',
    templateUrl: './ttm-tickets.component.html',
    styleUrls: ['./ttm-tickets.component.scss']
})
export class TtmTicketsComponent extends CodaltComponent implements OnInit, AfterViewInit {
    @ViewChild('searchInput') searchInput: ElementRef<HTMLInputElement>;
    dataSource: TtmTicketDataSource;
    tickets$: Observable<TtmTicket[]>;
    ttmTypes: TtmType[];
    ttmStatuses: TtmStatus[];
    images: EntityImage[];
    users: User[];

    readonly sortOptions: { value: string; label: string }[] = [
        {value: 'created_at', label: 'Aangemaakt'},
        {value: 'type', label: 'Type'},
        {value: 'department', label: 'Afdeling'},
        {value: 'user_id', label: 'Naam'},
        {value: 'assignee_id', label: 'Toegewezen aan'},
        {value: 'ttm_id', label: 'TVM ID'},
        {value: 'status', label: 'Status'},
        {value: 'comment', label: 'Opmerking'}
    ];

    departments = TtmTicketDepartmentOptions;
    // Keeps the declared order of the departments, keyvalue sorts on key by default
    keepOrder = () => 0;

    userIdControl = new FormControl<number | null>(null);
    departmentControl = new FormControl<string | null>(null);
    // Only the coordinator sees tickets of every department, so only they get the department filter
    showDepartmentFilter = AuthorisationService.hasRole(Roles.Codalt);
    sortByControl = new FormControl<string>('created_at', {nonNullable: true});
    sortDirection: 'asc' | 'desc' = 'desc';

    filterForm: FormGroup = new FormGroup({
        userId: this.userIdControl,
    });

    constructor(private ttmTicketService: TtmTicketService,
                private confirmDialogService: ConfirmDialogService,
                private projectService: ProjectService,
                private userService: UserService,
                private ttmService: TtmService,
                private dialog: MatDialog,
                private title: Title,
                private router: Router) {
        super();
    }


    // Notifications of all tickets of the user, per ticket they can still be toggled on the card
    ticketNotifications = LocalStorage.user?.email_ticket_notifications ?? true;

    pageSize = 20;
    loading = false;
    allLoaded = false;

    onScroll(event: Event) {
        const target = event.target as HTMLElement;
        if (this.loading || this.allLoaded) return;
        if (target.scrollTop + target.clientHeight >= target.scrollHeight - 10) {
            this.loadMoreTickets();
        }
    }

    info() {
        this.confirmDialogService.confirm('TVM-tickets',
            `Hier zie je de tickets gerelateerd aan TVM's. Je kunt een ticket aanmaken voor verschillende afdelingen:<br>
            - <strong>Technisch</strong>: Voor technische problemen in de app (Codalt)<br>
            - <strong>Ontwerp</strong>: Voor ontwerp-gerelateerde vragen of aanpassingen<br>
            - <strong>Projectcoördinatie</strong>: Voor projectcoördinatie vraagstukken<br><br>
            Je kunt een TVM melden via de 'Opties' in het detailscherm of door rechts (of lang op mobiel) te klikken/drukken op de drie puntjes in de lijst.`, 'Sluiten', null).then(() => {
        });
    }

    ttmDetails(ttm: Ttm, ticket) {
        if (!ttm) {
            return;
        }

        const project$ = this.projectService.get(ttm.project_id);
        this.subscriptions.add(combineLatest([project$]).subscribe(([project]) => {
            this.dialog.open(TtmDetailsDialogComponent, {
                width: '700px',
                maxWidth: '98vw',
                data: {ttm, project: project.data, ttmStatuses: this.ttmStatuses, ttmTypes: this.ttmTypes, ticket: ticket}
            });
        }));
    }

    ngOnInit() {
        this.title.setTitle('Tickets - TSNed App');
        this.dataSource = new TtmTicketDataSource(this.ttmTicketService);
        this.tickets$ = this.dataSource.tickets$;

        this.applySorting();

        const statuses$ = this.ttmService.statuses();
        const types$ = this.ttmService.types();
        this.subscriptions.add(
            this.ttmTicketService.getAllUsersRelatedToTickets().subscribe(
                {
                    next: (response) => {
                        this.users = response.data;
                        // Set default filter to current user
                        const currentUser = LocalStorage.user;
                        if (currentUser && this.users.some(m => m.id === currentUser.id)) {
                            if (AuthorisationService.hasAnyRole([Roles.Manager, Roles.Drawer])) {
                                this.userIdControl.setValue(currentUser.id);
                            }
                        }
                    }
                }
            )
        )

        this.subscriptions.add(combineLatest([statuses$, types$]).subscribe(([statuses, types]) => {
            this.ttmStatuses = statuses.data;
            this.ttmTypes = types.data;
        }));

        this.subscriptions.add(this.userIdControl.valueChanges.subscribe(value => {
            this.resetAndLoadTickets();
        }));

        this.subscriptions.add(this.departmentControl.valueChanges.subscribe(() => {
            this.resetAndLoadTickets();
        }));

        this.subscriptions.add(this.sortByControl.valueChanges.subscribe(() => {
            this.resetAndLoadTickets();
        }));

        // Initial load in ngOnInit, loading it in ngAfterViewInit causes NG0100 on `loading`
        this.resetAndLoadTickets();
    }

    delete(ticket: TtmTicket) {
        const pipe = new TtmTicketTypePipe();
        this.confirmDialogService.confirm(
            'Verwijderen bevestigen',
            `Weet u zeker dat u de melding van type ${pipe.transform(ticket.type).toLocaleLowerCase()} van ${ticket.user?.name} wilt verwijderen?`,
            'Verwijderen',
            'Behouden').then(() => {
            this.ttmTicketService.deleteTicket(ticket.id).subscribe(() => {
                this.resetAndLoadTickets();
            });
        }, () => {
        });
    }

    ngAfterViewInit() {
        fromEvent<KeyboardEvent>(this.searchInput.nativeElement, 'keyup')
            .pipe(debounceTime(300)).subscribe(() => {
            this.resetAndLoadTickets();
        });
    }

    private resetAndLoadTickets() {
        this.allLoaded = false;
        this.dataSource.resetTickets();
        this.loadMoreTickets(true);
    }

    loadMoreTickets(reset = false) {
        if (this.loading || this.allLoaded) return;
        this.loading = true;
        this.dataSource.loadMoreTickets({
            orderBy: this.sortByControl.value,
            orderDirection: this.sortDirection,
            search: this.searchInput?.nativeElement.value,
            assigneeId: this.userIdControl.value,
            department: this.departmentControl.value,
            pageSize: this.pageSize,
            reset
        }).subscribe(loadedAll => {
            this.loading = false;
            this.allLoaded = loadedAll;
        });
    }

    // Overwrites the setting of every ticket, the loaded tickets are updated the same way instead of fetched again
    toggleAllNotifications() {
        this.subscriptions.add(
            this.userService.toggleTicketNotifications().subscribe(response => {
                // Only take over the setting; the response user doesn't always include the roles with features
                LocalStorage.user = {...LocalStorage.user, email_ticket_notifications: response.data.email_ticket_notifications};
                this.ticketNotifications = response.data.email_ticket_notifications;
                this.dataSource.setNotifications(this.ticketNotifications);
            })
        );
    }

    toggleSortDirection() {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
        this.resetToFirstPageAndLoad();
    }

    private applySorting() {
        this.dataSource.setSorting(this.sortByControl.value, this.sortDirection);
    }

    private resetToFirstPageAndLoad() {
        this.applySorting();
        this.resetAndLoadTickets();
    }
}
